import {
  CircularProgress,
  Dialog,
  DialogContent,
  makeStyles,
} from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'

const LoadingModal = ({ loading }) => {
  const classes = useStyles()

  return (
    <Dialog open={loading}>
      <DialogContent className={classes.loadingContainer}>
        <CircularProgress />
        <span className={classes.loadingText}>Please wait a moment ....</span>
      </DialogContent>
    </Dialog>
  )
}

export default LoadingModal

const useStyles = makeStyles({
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  loadingText: {
    fontSize: '14px',
    color: COLORS.MEDIUM_BLUE,
  },
})
